import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useParams } from "react-router-dom";
import VehicleHireTemplateForm from "./VehicleHireTemplateForm";
import { EditMode } from "../../../../enums/EditMode";
export default function VehicleHireTemplateEditPage() {
    const params = useParams();
    let action = 'Edit';
    let mode = EditMode.EDIT;
    if (params.id === "create") {
        action = 'Create';
        mode = EditMode.CREATE;
    }
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article", children: [_jsxs("h2", { className: "article-title", children: [action, " Vehicle & Driver Hire Favourite"] }), _jsx(VehicleHireTemplateForm, { mode: mode, vehicleHireTemplateId: params.id ? Number(params.id) : undefined })] }) }));
}
